<template>
  <div class="list-wrap"
       :class="`${ 'mode-' + mode }`">
    <div class="list-header">
      <template v-if="!isCustomNode">
        <strong class="cell-domain">Domain</strong>
        <strong class="cell-path">Path</strong>
        <strong class="cell-title">Page Title</strong>
      </template>
      <template v-else>
        <strong class="cell-value">{{ $t('ranking.column.customData') }}</strong>
      </template>

    </div>
    <ui-fake-scroll-box ref="scrollBox"
                        @onScroll="onScroll">
      <ul>
        <li v-for="(item) in listDataArray"
            :key="item._id"
            :class="{
              'bookmarked': item.bookmark || isCustomNode,
              'selected': selectedId === item._id,
              'is-mobile': isMobile,
              'custom': isCustomNode
            }"
            :data-id="item._id"
            @click="onItemClick">
          <div class="row">
            <template v-if="!isCustomNode">
              <span v-if="reportView !== 'ranking' && item._thumbnailsMap && item._thumbnailsMap[selectedDevice]"
                    class="thumbnail"
                    :class="{
                    'bottom': listScrollTop > item._top
                  }"
                    :style="{
                    'margin-bottom': -(item._top - listScrollTop + 128 + (listScrollTop > item._top ? item._height : 0)) + 'px'
                  }"
                    :data-device="selectedDevice">
              <span class="image" v-if="item._thumbnailsMap">
                <img :src="item._thumbnailsMap[selectedDevice]" alt="" />
              </span>
            </span>
              <span class="cell-domain">{{ item._domain }}</span>
              <span class="cell-path">{{ item._path }}</span>
              <span class="cell-title">{{ item.title }}</span>
              <span v-if="mode === 'manage'"
                    class="cell-button">
                <ui-button size="small"
                           :loading="item._loading"
                           :iconName="!item.bookmark ? 'icon--reset' : ''"
                           @click="onToggleButtonClick">
                  {{ item.bookmark ? $t('bookmark.remove') : $t('common.undo') }}
                </ui-button>
              </span>
            </template>
            <template v-else>
              <span class="cell-bullet">
                <span class="bullet" :style="{'background-color': item.customColor}"></span>
              </span>
              <span class="cell-value">
                {{item.customValue}}
              </span>
            </template>
          </div>
        </li>
      </ul>
    </ui-fake-scroll-box>
  </div>
</template>

<script>
import browser from '@/libs/browser'

import UiButton from '@/components/ui/UiButton'
import UiFakeScrollBox from '@/components/ui/UiFakeScrollBox'
import BaBookmarkNeedMore from '@/components/targeting/BookmarkNeedMore'

export default {
  name: 'BaBookmarkList',
  components: {
    UiButton,
    UiFakeScrollBox
  },
  props: {
    mode: {
      type: String,
      default: 'targeting',
      validator: (value) => {
        return ['targeting', 'manage'].indexOf(value) > -1
      }
    },
    listDataArray: {
      type: Array,
      required: true
    },
    selectedDevice: {
      type: String,
      required: true
    },
    selectedId: {
      type: [Number, String],
      required: true
    },
    isCustomNode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listScrollTop: 0
    }
  },
  computed: {
    reportView () {
      return this.$route.name
    },
    isMobile () {
      return browser.isMobile
    }
  },
  watch: {
  },
  created () {
  },
  mounted () {
    requestAnimationFrame(() => {
      const $selected = this.$el.querySelector('.selected')
      if ($selected) {
        this.$refs.scrollBox.scrollTop($selected.offsetTop - 10)
      }
    })
  },
  beforeDestroy () {
    this.refresh()
  },
  methods: {
    onScroll (scrollTop) {
      this.listScrollTop = scrollTop
    },
    onItemClick (e) {
      const id = e.currentTarget.dataset.id
      this.$emit('onSelect', isNaN(id) ? id : parseInt(id))
    },
    onToggleButtonClick (e) {
      const id = e.currentTarget.parentNode.parentNode.parentNode.dataset.id
      this.$emit('onToggleBookmark', isNaN(id) ? id : parseInt(id))
    },
    refresh () {
      this.$refs.scrollBox.refresh()
    }
  }
}
</script>

<style lang="scss" scoped>
.list-wrap {
  width: 100%;
  height: 100%;

  .mode-targeting {
    [class*="cell-"] {
      &.cell-domain {
        padding-left: 70px;
      }
      &.cell-title {
        padding-left: 56px;
      }
    }

    li {
      .row {
        &:before {
          position: absolute;
          left: 12px;
          top: 50%;
          width: 18px;
          height: 18px;
          content: '';
          margin-top: -9px;
          border: solid 2px #aaa;
          border-radius: 100%;
          box-sizing: border-box;
          background-color: #fff;
          transition: border-color 0.2s ease-out;
        }
        &:after {
          position: absolute;
          left: 16px;
          top: 50%;
          width: 10px;
          height: 10px;
          content: '';
          margin-top: -5px;
          border-radius: 100%;
          background-color: #ec0047;
          opacity: 0;
          transition: opacity 0.2s ease-out;
        }

        .thumbnail {
          left: 90px;
        }

        .cell-domain {
          &:after {
            left: 40px;
          }
        }
      }

      &.selected {
        .row {
          &:before {
            border-color: #ec0047;
          }
          &:after {
            opacity: 1;
          }
        }
      }
    }
  }
}

.ui-fake-scroll-box {
  & /deep/ {
    .scroll-box {
      padding: 10px 20px;
      box-sizing: border-box;
    }

    .fake-scroll-track {
      z-index: 2;
    }
  }
}

[class*="cell-"] {
  word-break: break-all;

  &.cell-domain {
    width: 200px;
    padding-left: 40px;
  }
  &.cell-path {
    width: 220px;
    padding-left: 30px;
  }
  &.cell-title {
    width: 220px;
    padding-left: 30px;
  }
  &.cell-button {
    width: 115px;
    text-align: right;
    padding-right: 5px;

    button.ui-btn.size--small {
      min-width: 90px;
      font-weight: 500;
      text-align: center;
    }
  }
  &.cell-bullet {
    position: relative;
    width: 20px;
    padding-left: 50px;
    & .bullet {
      position: absolute;
      display: inline-block;
      width: 10px;
      height: 10px;
      top: 50%;
      transform: translate(0, -50%);
      border: solid 1px rgba(0, 0, 0, 0.1);
      background-color: #bbbbbb;
      border-radius: 12px;
      vertical-align: middle;
      transition: border-color 0.15s ease;
    }
  }
  &.cell-value {
    width: 772px;
    padding-left: 10px;
  }
}

.list-header {
  position: absolute;
  left: 20px;
  right: 0;
  top: -24px;
  font-size: 13px;
  font-weight: 500;
  color: #767676;
  white-space: nowrap;
  line-height: 15px;
  display: flex;
}

li {
  position: relative;
  border-bottom: 1px solid #d7d7d7;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:before {
    position: absolute;
    left: 0;
    right: 0;
    top: 5px;
    bottom: 5px;
    content: '';
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
    box-shadow: inset 0 0 0 0 #ec0047;
    transition: 0.2s ease-out;
    transition-property: background-color, box-shadow;
  }

  &:not(.is-mobile):hover {
    &:before {
      background-color: rgba(0, 0, 0, 0.08);
    }

    .row {
      .thumbnail {
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition: opacity 0.15s ease-out, transform 0.3s $ease-out-quart;

        &.bottom {
          transform: translate3d(0, calc(100% - 16px), 0);
        }
      }
    }
  }

  &.selected {
    &:before {
      background-color: #fff !important;
      box-shadow: inset 0 0 0 2px #ec0047 !important;
    }

    .row {
      color: #020202 !important;
    }
  }

  &.bookmarked {
    .row {
      .thumbnail {
        &:after {
          opacity: 1;
        }
      }

      .cell-domain {
        &:after {
          opacity: 1;
        }
      }
    }
  }

  &:not(.bookmarked) {
    .row {
      [class*="cell-"]:not(.cell-button) {
        opacity: 0.3;
      }
    }
  }

  .row {
    position: relative;
    font-size: 13px;
    color: #444;
    line-height: 18px;
    padding: 16px 0;
    display: flex;
    align-items: center;
    transition: color 0.2s ease-out;

    .thumbnail {
      position: fixed;
      left: 50px;
      bottom: calc(100% - 7px);
      width: 190px;
      padding: 5px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
      opacity: 0;
      pointer-events: none;
      z-index: 2;
      transform: translate3d(0, 15px, 0);
      transition: opacity 0.01s ease-out, transform 0.1s $ease-out-quart;

      &[data-device="desktop"] {
        &:before {
          left: 52px;
        }
      }
      &[data-device="tablet"] {
        width: 140px;
      }
      &[data-device="phone"] {
        width: 90px;
      }

      &.bottom {
        transform: translate3d(0, calc(100% - 16px - 15px), 0);

        &:before {
          top: auto;
          bottom: 100%;
          margin: 0 0 -5px -5px;
          border-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.2) transparent transparent;
        }
      }

      &:before {
        position: absolute;
        left: 50%;
        top: 100%;
        width: 8px;
        height: 8px;
        content: '';
        margin: -5px 0 0 -5px;
        border: 1px solid;
        border-color: transparent transparent rgba(0, 0, 0, 0.25) rgba(0, 0, 0, 0.25);
        background-color: #fff;
        transform: rotate(-45deg);
      }

      &:after {
        position: absolute;
        left: 5px;
        top: 5px;
        width: 43px;
        height: 43px;
        content: '';
        background: url('../../assets/img/targeting/icon--bookmark-ribbon.svg') no-repeat 0 0 / 100%;
        opacity: 0;
        transition: opacity 0.1s ease-out;
      }

      .image {
        position: relative;
        border-radius: 4px;
        display: block;
        overflow: hidden;

        &:after {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          content: '';
          background-color: rgba(0, 0, 0, 0.15);
        }
      }
      img {
        width: 100%;
        display: block;
      }
    }

    [class*="cell-"]:not(.cell-button) {
      transition: opacity 0.2s ease-out;
    }

    .cell-domain {
      &:after {
        position: absolute;
        left: 10px;
        top: 50%;
        width: 20px;
        height: 20px;
        content: '';
        margin-top: -10px;
        background-image: url(../../assets/img/ranking/icon--favorite.svg);
        opacity: 0;
        transition: opacity 0.1s ease-out;
      }
    }
  }
}

.need-more {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -120px;
  height: 89px;
}
</style>
